import React from "react";
import { Select, Form } from "antd";
import "./styles.scss";

const { Option } = Select;

const DropDownComponent = ({
  name,
  label,
  options = [],
  placeholder = "Select an option",
  required = false,
  disabled = false,
  loading = false,
  allowClear = true,
  mode = "single",
  style = {},
  rules = [],
  initialValue,
  onChange,
  className = "",
  value,
  showSearch = false,
  optionFilterProp = "label",
  filterOption = undefined,
  maxTagCount = undefined,
}) => {
  return (
    <Form.Item
      name={name}
      label={label}
      rules={[
        {
          required: required,
          message: `Please select ${label}`,
        },
        ...rules,
      ]}
      initialValue={initialValue}
    >
      <Select
        mode={mode}
        placeholder={placeholder}
        className={`master-dropdown ${className}`}
        disabled={disabled}
        loading={loading}
        allowClear={allowClear}
        style={style}
        onChange={onChange}
        value={value}
        showSearch={showSearch}
        optionFilterProp={optionFilterProp}
        filterOption={filterOption}
        maxTagCount={maxTagCount}
        labelInValue={false}
      >
        {options.map((option) => (
          <Option
            key={option.value}
            value={option.value}
            label={option.label}
            disabled={option.disabled}
          >
            {option.label}
          </Option>
        ))}
      </Select>
    </Form.Item>
  );
};

export default DropDownComponent; 
